<template>
  <ion-header class="ion-no-border">
    <ion-toolbar class="-not-fixed">
      <ion-buttons slot="start">
        <ion-button @click="modalController.dismiss()">
          <ion-icon
            :src="require('@lib/assets/icons/icon_zurueck.svg')"
            slot="start"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content ref="content" class="ion-padding">
    <ion-grid fixed>
      <h1 v-if="title">{{ title }}</h1>
      <ion-row>
        <ion-col size="12" size-md>
          <ion-item lines="none">
            <ion-label position="stacked">Vorname</ion-label>
            <ion-input
              placeholder="Vorname"
              v-model="formInput['Firstname']"
              :disabled="$route.query.checkId"></ion-input>
          </ion-item>
          <input-error id="Firstname" />
        </ion-col>
        <ion-col size="12" size-md>
          <ion-item lines="none">
            <ion-label position="stacked">Nachname</ion-label>
            <ion-input
              placeholder="Nachname"
              v-model="formInput['Lastname']"
              :disabled="$route.query.checkId"></ion-input>
          </ion-item>
          <input-error id="Lastname" />
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12" size-md>
          <ion-item lines="none">
            <ion-label position="stacked">Versicherungsnummer</ion-label>
            <ion-input
              placeholder=""
              v-model="formInput['ExternalId']"
              :disabled="$route.query.checkId"></ion-input>
          </ion-item>
          <input-error id="ExternalId" />
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12" size-md>
          <ion-item lines="none">
            <ion-label position="stacked">E-Mail Adresse</ion-label>
            <ion-input
              placeholder="adresse@mail.com"
              v-model="formInput['Email']"></ion-input>
          </ion-item>
          <input-error id="Email" />
        </ion-col>
        <ion-col size="12" size-md>
          <ion-item lines="none">
            <ion-label position="stacked">Mobilnummer</ion-label>
            <ion-input
              placeholder="+49XXXXXXXXXX"
              v-model="formInput['Msisdn']"></ion-input>
          </ion-item>
          <input-error id="Msisdn" />
        </ion-col>
      </ion-row>
      <ion-item v-if="showNote && !$route.query.checkId" lines="none">
        <ion-label position="stacked">Anliegen</ion-label>
        <ion-textarea rows="5" v-model="formInput.Note"></ion-textarea>
      </ion-item>
      <ion-list lines="none" v-if="routing === 'ARAG Case Management Mental'">
        <ion-radio-group v-model="aragPartner">
          <h6>Ich möchte gerne Hilfe erhalten von:</h6>
          <ion-item>
            <ion-label color="primary">therapeutenverbund</ion-label>
            <ion-radio slot="start" value="therapeutenverbund"></ion-radio>
          </ion-item>
          <ion-item>
            <ion-label color="primary">MindDoc</ion-label>
            <ion-radio slot="start" value="MindDoc"></ion-radio>
          </ion-item>
        </ion-radio-group>
      </ion-list>
      <div
        :class="{
          'ion-margin-top': routing !== 'ARAG Case Management Mental',
        }">
        <!-- <component
          :is="'Privacy' + routing.replaceAll(' ', '')"
          :showLogo="false"
          :showNextButton="false"
          @checked="
            isPrivacyChecked = true;
            formInput.Privacy1Label = $event.privacy1Label;
            formInput.Privacy2Label = $event.privacy2Label;
          "
          @unchecked="isPrivacyChecked = false"
        ></component> -->
        <component
          :is="getPrivacyName()"
          :routing="routing"
          @privacy-roodie-checked="isPrivacyRoodieChecked = $event"
          @checked="
            isPrivacyChecked = true;
            formInput.Privacy1Label = $event?.privacy1Label;
            formInput.Privacy2Label = $event?.privacy2Label;
          "
          @unchecked="isPrivacyChecked = false"
          @should-save-checked="shouldSave = $event"
          :showShouldSave="false"
          from="contact"></component>
      </div>
      <div class="ion-text-center">
        <ion-button
          :disabled="!isPrivacyChecked"
          @click="submit"
          class="ion-margin-top"
          >Absenden</ion-button
        >
      </div>
    </ion-grid>
  </ion-content>
</template>

<script>
import {
  IonItem,
  IonLabel,
  IonContent,
  IonButton,
  IonIcon,
  IonRow,
  IonCol,
  IonHeader,
  IonToolbar,
  IonButtons,
  modalController,
  IonInput,
  IonGrid,
  IonTextarea,
  IonList,
  IonRadioGroup,
  IonRadio,
} from "@ionic/vue";
import { chevronBack } from "ionicons/icons";
import InputError from "@/components/InputError";
import { apiGetUser } from "@/api/user";
import EndModal from "@/components/EndModal";
import PrivacyARAGCaseManagement from "@/components/PrivacyArag";
import PrivacyARAGCaseManagementZahn from "@/components/PrivacyAragZahn";
import PrivacyARAGCaseManagementMental from "@/components/PrivacyAragMental";
import PrivacyBetterDoc from "@arag/components/PrivacyBetterDoc";
import { contact } from "@/api/contact";
import { saveCheck } from "@/api/roodiecheck";
import axios from "@/plugins/axios";

export default {
  components: {
    IonItem,
    IonLabel,
    IonContent,
    IonButton,
    IonIcon,
    IonRow,
    IonCol,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonInput,
    IonGrid,
    InputError,
    IonTextarea,
    PrivacyARAGCaseManagement,
    PrivacyARAGCaseManagementZahn,
    PrivacyARAGCaseManagementMental,
    PrivacyBetterDoc,
    IonList,
    IonRadioGroup,
    IonRadio,
  },
  props: {
    routing: {
      required: true,
      type: String,
    },
    title: {
      required: false,
      type: String,
      default: "",
    },
    showNote: {
      required: false,
      type: Boolean,
      default: true,
    },
    from: {
      required: false,
      type: String,
      default: "",
    },
    answers: {
      required: false,
      type: Array,
      default: () => {
        return [];
      },
    },
    selectedSentence: {
      required: false,
      type: String,
      default: "",
    },
    reference: {
      required: false,
      type: String,
      default: "",
    },
  },
  data() {
    return {
      formInput: {
        Firstname: "",
        Lastname: "",
        ExternalId: "",
        Email: "",
        Msisdn: "",
        Note: "",
        Privacy1Label: "",
        Privacy2Label: "",
      },
      aragPartner: "therapeutenverbund",
      isPrivacyChecked: false,
      isPrivacyRoodieChecked: false,
      shouldSave: false,
    };
  },
  mounted() {
    apiGetUser().then(() => {
      this.formInput.Firstname = this.$store.state.user.FirstName;
      this.formInput.Lastname = this.$store.state.user.LastName;
      this.formInput.ExternalId = this.$store.state.user.ExternalId;
      this.formInput.Email = this.$store.state.user.Email;
      this.formInput.Msisdn = this.$store.state.user.Msisdn;
    });
  },
  setup() {
    return { modalController, chevronBack };
  },
  methods: {
    getPrivacyName() {
      let result = "Privacy" + this.routing.replaceAll(" ", "");
      // if (this.$route.query.checkId) {
      //   result = "PrivacyBetterDoc";
      // } else if (this.routing.startsWith("ARAG Case Management")) {
      //   result = "PrivacyARAGCaseManagement";
      // }
      result = "PrivacyBetterDoc";
      return result;
    },
    async submit() {
      this.$store.commit("setShowLoading", true);
      const formInputChanged = { ...this.formInput };
      if (this.routing === "ARAG Case Management Mental") {
        formInputChanged.AragPartner = this.aragPartner;
      }
      if (this.$route.query.checkId) {
        const sendCaseResponse = await axios.post(
          "?Mode=General&Function=SendCase",
          {
            ...formInputChanged,
            Id: this.$route.query.checkId,
            Routing: this.routing,
            ShareCheck: this.isPrivacyRoodieChecked,
            SaveCheck: this.shouldSave,
          }
        );
        if (sendCaseResponse.data.Status === "Success") {
          this.$router.push({ name: "home" });
        } else {
          return;
        }
      } else {
        if (this.from === "chat") {
          const response = await saveCheck(this.answers, this.selectedSentence);
          if (response.data.Status !== "Success") {
            return;
          }
        }
        const contactData = {
          ...formInputChanged,
          Routing: this.routing,
          Reference: this.reference || this.routing,
          Privacy1: this.isPrivacyChecked,
          Privacy2: this.isPrivacyChecked,
        };
        const contactResponse = await contact(contactData);
        if (contactResponse.data.Status === "Success") {
          this.$gtm.trackEvent({
            // event: null, // Event type [default = 'interaction'] (Optional)
            category: "Kontakt",
            action: "Absenden",
            label: this.routing,
            value: 1,
            // noninteraction: false, // Optional
          });
        } else {
          return;
        }
      }
      this.modalController.dismiss({ isSent: true }).then(() => {
        if (this.from !== "chat") {
          this.openEndModal();
        }
      });
    },
    async openEndModal() {
      const modal = await modalController.create({
        component: EndModal,
        componentProps: {
          routing: this.routing,
        },
      });
      return modal.present();
    },
  },
};
</script>

<style></style>
